import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BookingInfoProperties, MealAirArabiaProperties, PassengerCreationResponse } from '../Models/BookingPassengerTicketIssuanceProperties';
import { CurrencyConversionProperties } from '../Models/CurrencyConversionProperties';
import { PostAncillaryGetProperties } from '../Models/PostModificationProperties';

@Injectable({
  providedIn: 'root'
})
export class PostTicketingModificationService {
  baseUrl = environment.baseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }
 
  AddSsrReq(obj): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/PostTicketingModification/PostANCIAddSsr', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  SSRIssueTicket(obj): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/PostTicketingModification/PostSSRIssueTicket', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  PostANCIAvailiabilityEmirates(bookingEmailObj): Observable<PostAncillaryGetProperties> {
    return this.http.post<boolean>(this.baseUrl + '/PostTicketingModification/PostANCIAvailiability', bookingEmailObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }


  ExchangeAddSsrReq(obj): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/PostTicketingModification/ExchangePostANCIAddSsr', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  ExchangeSSRIssueTicket(obj): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/PostTicketingModification/ExchnagePostSSRIssueTicket', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  ExchangePostANCIAvailiabilityEmirates(bookingEmailObj): Observable<PostAncillaryGetProperties> {
    return this.http.post<boolean>(this.baseUrl + '/PostTicketingModification/ExchangePostANCIAvailiabilityEmirates', bookingEmailObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  InitialAddSsrReq(obj): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/PostTicketingModification/InitialPostANCIAddSsr', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  InitialSSRIssueTicket(obj): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/PostTicketingModification/InitialPostSSRIssueTicket', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  InitialPostANCIAvailiabilityEmirates(bookingEmailObj): Observable<PostAncillaryGetProperties> {
    return this.http.post<boolean>(this.baseUrl + '/PostTicketingModification/InitialPostANCIAvailiabilityEmirates', bookingEmailObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  PIAANCIAvailiability(obj): Observable<MealAirArabiaProperties> {
    return this.http.post<MealAirArabiaProperties>(this.baseUrl + '/PostTicketingModification/PIAANCIAvailiability', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  InitialVoidReq(obj): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/PostTicketingModification/InitialVoidReq', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  ExchangeVoidReq(obj): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/PostTicketingModification/ExchangeVoidReq', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  InitialRefundReq(obj): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/PostTicketingModification/InitialRefundReq', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  ExchangeRefundReq(obj): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/PostTicketingModification/ExchangeRefundReq', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  AirBlueANCIAvailiability(obj): Observable<MealAirArabiaProperties> {
    return this.http.post<MealAirArabiaProperties>(this.baseUrl + '/PostTicketingModification/AirBlueANCIAvailiability', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  createBookingSeatRecord(obj): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/FlightSearch/ModifyBookingSeatAirBlue', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  createBookingExtraBaggageRecord(obj): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/FlightSearch/ModifyBaggageAirBlue', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
}
